import { modalRenderer } from '~/modal/modalRendererRegistry';
import { OverlayLoaderComponent } from './overlayLoader.component';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    Loader: undefined;
  }
}

modalRenderer.register('Loader', ({ isOpen }) => isOpen ? <OverlayLoaderComponent /> : null);
